import { connect } from "react-redux";

import { reducer, mapStateToProps, mapDispatchToProps } from "./AdminPage.state";
import AdminPage from "./AdminPage";

export default connect(mapStateToProps, mapDispatchToProps)(AdminPage);

export { reducer, mapStateToProps, mapDispatchToProps };
